<template>
  <div>
    <header class="nav" :class="{ 'nav--solid': scrolled }">
      <div class="nav-inner">
        <a class="brand" href="#hero" @click.prevent="navigateTo(_routes[0])">
          <span class="brand-mark">JC</span>
          <span class="brand-text">
            julio<span class="brand-dot">.</span>dev
          </span>
        </a>

        <nav v-if="!isMobile" class="nav-links">
          <button
            v-for="item in _routes"
            :key="item.id"
            type="button"
            class="nav-link"
            :class="{ 'nav-link--active': activeSection === item.id }"
            @click="navigateTo(item)"
          >
            <span class="nav-link-index">{{ item.index }}</span>
            {{ item.label }}
          </button>
        </nav>

        <a
          v-if="!isMobile"
          class="nav-cta"
          href="#contact"
          @click.prevent="goToContact"
        >
          Fale comigo
        </a>

        <button
          v-if="isMobile"
          type="button"
          class="nav-burger"
          :aria-expanded="String(drawer)"
          aria-label="Abrir menu"
          @click="drawer = !drawer"
        >
          <v-icon size="24">{{ drawer ? "mdi-close" : "mdi-menu" }}</v-icon>
        </button>
      </div>
    </header>

    <v-navigation-drawer
      v-if="isMobile"
      v-model="drawer"
      class="side-drawer"
      right
      temporary
      app
      width="270"
    >
      <div class="drawer-head mono">navegação</div>

      <nav class="drawer-links">
        <button
          v-for="item in _routes"
          :key="item.id"
          type="button"
          class="drawer-link"
          :class="{ 'drawer-link--active': activeSection === item.id }"
          @click="navigateTo(item)"
        >
          <span class="nav-link-index">{{ item.index }}</span>
          {{ item.label }}
        </button>
      </nav>

      <a class="drawer-cta" href="#contact" @click.prevent="goToContact">
        Fale comigo
      </a>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: "NavBar",

  data() {
    return {
      drawer: false,
      scrolled: false,
      activeSection: "hero",
      observer: null,
    };
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    _routes() {
      return [
        { index: "01", id: "hero", label: "Início" },
        { index: "02", id: "stack", label: "Stack" },
        { index: "03", id: "projects", label: "Projetos" },
        { index: "04", id: "career", label: "Carreira" },
        { index: "05", id: "profile", label: "Perfil" },
        { index: "06", id: "contact", label: "Contato" },
      ];
    },
    _options() {
      return { duration: 700, offset: 0, easing: "easeInOutCubic" };
    },
  },

  methods: {
    navigateTo(item) {
      this.drawer = false;
      this.activeSection = item.id;
      this.$vuetify.goTo(`#${item.id}`, this._options);
    },

    goToContact() {
      this.navigateTo(this._routes.find((item) => item.id === "contact"));
    },

    onScroll() {
      this.scrolled = window.scrollY > 24;
    },

    watchSections() {
      if (typeof IntersectionObserver === "undefined") return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries
            .filter((entry) => entry.isIntersecting)
            .forEach((entry) => {
              this.activeSection = entry.target.id;
            });
        },
        { rootMargin: "-45% 0px -50% 0px", threshold: 0 }
      );

      this._routes.forEach(({ id }) => {
        const el = document.getElementById(id);
        if (el) this.observer.observe(el);
      });
    },
  },

  mounted() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.onScroll();
    this.$nextTick(this.watchSections);
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
    if (this.observer) this.observer.disconnect();
  },
};
</script>

<style lang="scss" src="./style.scss" scoped />
